import { render, staticRenderFns } from "./FraisTransportTranches.vue?vue&type=template&id=4d732d56&scoped=true&"
import script from "./FraisTransportTranches.vue?vue&type=script&lang=js&"
export * from "./FraisTransportTranches.vue?vue&type=script&lang=js&"
import style0 from "./FraisTransportTranches.vue?vue&type=style&index=0&id=4d732d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d732d56",
  null
  
)

component.options.__file = "FraisTransportTranches.vue"
export default component.exports